import Immutable from 'seamless-immutable'

import * as actions from './actions'

const initialState = Immutable.from({
  completions: [],
  chosenSuggestion: null,
  isFetching: false,
})

const autocomplete = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actions.REQUEST_COMPLETIONS:
      return state.set('isFetching', true)
    case actions.RECEIVE_COMPLETIONS:
      if (error) {
        return state.set('completions', []).set('isFetching', false)
      }
      return state.set('completions', payload).set('isFetching', false)
    case actions.CLEAR_COMPLETIONS:
      return initialState
    case actions.CHOOSE_SUGGESTION:
      return state.set('chosenSuggestion', payload)
    default:
      return state
  }
}

export default autocomplete
